import { Rma } from "../../api/api-generated";
import { stringIncludesIgnoreCaseIgnoreNullSubstring } from "../../utils/comparisons";
import { truncateISOString } from "../../utils/dateTime";
import { CustomerRmaFilter } from "./customerRmaTypes";

export const filterRmas = (item: Rma, filters: CustomerRmaFilter): boolean => {
  if (
    filters.nameId &&
    !stringIncludesIgnoreCaseIgnoreNullSubstring(item.nameId, filters.nameId)
  )
    return false;
  if (
    filters.serial &&
    !stringIncludesIgnoreCaseIgnoreNullSubstring(
      item.hardware.serial,
      filters.serial
    )
  )
    return false;
  if (
    filters.shipDateFrom &&
    (item.shipDate === null ||
      truncateISOString(item.shipDate) <
        truncateISOString(filters.shipDateFrom))
  )
    return false;
  if (
    filters.shipDateTo &&
    (item.shipDate === null ||
      truncateISOString(item.shipDate) > truncateISOString(filters.shipDateTo))
  )
    return false;
  return true;
};

export const filterConstraintChecker = (
  name: string,
  value: string,
  filters: CustomerRmaFilter
) => {
  if (name === "shipDateFrom") {
    if (filters.shipDateTo && filters.shipDateTo < value) return false;
  }
  if (name === "shipDateTo") {
    if (filters.shipDateFrom && filters.shipDateFrom > value) return false;
  }
  return true;
};
